import React from "react";

import { SortType } from "commons/types/api/common";
import { LoadTableDataInterface, SortDirection } from "commons/types/table";

export type DataTableContextType<T> = {
    loadTableData: LoadTableDataInterface;
    elements: Array<T>;
    sort: SortType;
};

export const DataTableContext = React.createContext<DataTableContextType<any>>({
    loadTableData: () => undefined,
    elements: [],
    sort: {
        col: "",
        dir: SortDirection.NotOrdered,
    },
});

export const useDataTableContext = <T,>() =>
    React.useContext<DataTableContextType<T>>(DataTableContext);
